import { MarketplaceSubGroup } from "@shared/types";
import Avo from "analytics/Avo";
import { AvoInspectorEnvValueType } from "avo-inspector/dist/AvoInspectorEnv";
import * as Inspector from "avo-inspector";

export const buildMarketPlaceGroupEvent = (
  marketplaceGroup: MarketplaceSubGroup,
  pagePosition: number
) => {
  return {
    marketplaceGroupId: marketplaceGroup.group_id,
    marketplaceGroupAverageRating: marketplaceGroup.avg_stars || -1,
    marketplaceGroupDiscountOffered: marketplaceGroup.discount,
    marketplaceGroupOffersFreeTrial: marketplaceGroup.has_free_trial,
    marketplaceGroupReviewsCount: marketplaceGroup.num_of_reviewers,
    marketplaceGroupDollarSignsCount: marketplaceGroup.price_number,
    marketplaceGroupPagePosition: pagePosition,
  };
};

export const getAvoInitParameters = (env: string | undefined) => {
  let inspectorEnv: AvoInspectorEnvValueType = Inspector.AvoInspectorEnv.Dev;
  let avoEnv = Avo.AvoEnv.Dev;
  let mixpanelToken = "fb34419ab61d090b687e45401c511163";

  if (env === "production") {
    inspectorEnv = Inspector.AvoInspectorEnv.Prod;
    avoEnv = Avo.AvoEnv.Prod;
    mixpanelToken = "0d7b60716e2e7c893e067e87ab93ccb1";
  } else if (env === "staging") {
    inspectorEnv = Inspector.AvoInspectorEnv.Staging;
    avoEnv = Avo.AvoEnv.Dev;
  }

  return {
    inspectorEnv,
    avoEnv,
    mixpanelToken,
  };
};
